/** @format */

import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconSignCancelOutline,
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldGlobalChipsComponent } from './global-chips.component';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldGlobalChipsComponent],
  exports: [HomefieldGlobalChipsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HomefieldGlobalChipsModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([homefieldIconSignCancelOutline]);
  }
}
